import {PropsWithChildren, useEffect, useState} from 'react';
import {createPortal} from 'react-dom';

interface Props extends PropsWithChildren {
  selector?: string;
  selectorId?: string;
  disabled?: boolean;
}

export const PortalSelectorHeadless = ({
  selector,
  selectorId,
  disabled,
  children,
}: Props) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (disabled) return;

    let element: HTMLElement | null = null;

    if (selectorId) {
      element = document.getElementById(selectorId);
    } else if (selector) {
      element = document.querySelector<HTMLElement>(selector);
    }

    if (!element) return;

    setElement(element);
  }, [selector, selectorId, disabled]);

  if (!element) {
    return children;
  }

  return createPortal(children, element);
};
